"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constantsClasses_1 = require("../data/constantsClasses");
var InputFilled = /** @class */ (function () {
    function InputFilled() {
        var _this = this;
        this.inputs = [];
        this.selects = [];
        var formFields = document.querySelectorAll('textarea, input, select');
        formFields.forEach(function (field) {
            if (field.nodeName == 'INPUT' || field.nodeName == 'TEXTAREA') {
                _this.inputs.push(field);
            }
            if (field.nodeName == 'SELECT') {
                _this.selects.push(field);
            }
        });
        this.inputs.forEach(function (input) {
            var el = input;
            _this.checkIfInputFilled(input);
            input.addEventListener('change', function () {
                _this.checkIfInputFilled(input);
            });
            if (el.type == 'date' || el.type == 'number') {
                _this.checkIfInputFilled(el);
                el.addEventListener('focusout', function () {
                    _this.checkIfInputFilled(el);
                });
            }
        });
        this.selects.forEach(function (select) {
            _this.checkIfSelectFilled(select);
            select.addEventListener('click', function () {
                _this.checkIfSelectFilled(select);
            });
        });
    }
    /**
     * Check if the currently selected input field has a value and set a class
     */
    InputFilled.prototype.checkIfInputFilled = function (el) {
        var input = el;
        input.value.length > 0 ? input.classList.add(constantsClasses_1.CLASS_FILLED) : input.classList.remove(constantsClasses_1.CLASS_FILLED);
    };
    /**
     * Check if the currently selected select field has a value and set a class
     */
    InputFilled.prototype.checkIfSelectFilled = function (el) {
        var select = el;
        select.value != '' ? select.classList.add(constantsClasses_1.CLASS_FILLED) : select.classList.remove(constantsClasses_1.CLASS_FILLED);
    };
    return InputFilled;
}());
exports.default = InputFilled;
